import { WEIGHT } from "components/Profile/constants";
import {
  MULTISELECT_NONE_OF_THESE,
  PAST_DIAGNOSIS2,
  PAST_WEIGHT_LOSS_MEDICATION
} from "config/tags";
import { getBMI } from "utils/bmi";
import { HIGH_BMI, OBESE_BMI } from "utils/eligibility";
import { findAnswerByQuestionTag } from "utils/questions";

// Shows error messages for high to obese BMI.
export const showEligibilityMessage = (
  profile,
  question,
  questions,
  answers,
  isAdding,
  selectedAnswer
) => {
  // Show only to users who are adding "None of these" on the comorbidities question.
  const pastDiagnosisQuestion = question?.tags?.includes(PAST_DIAGNOSIS2);
  const noneOfTheseAnswer = selectedAnswer?.tags?.includes(
    MULTISELECT_NONE_OF_THESE
  );
  const usedGlpAnswer = findAnswerByQuestionTag(
    PAST_WEIGHT_LOSS_MEDICATION,
    answers,
    questions
  );
  if (
    !pastDiagnosisQuestion ||
    !noneOfTheseAnswer ||
    !isAdding ||
    usedGlpAnswer === "Yes" ||
    profile?.isB2B
  ) {
    return false;
  }

  const metricHeight =
    profile.metric.heightUnit === "m"
      ? profile.metric.height * 100
      : profile.metric.height;
  const startingWeightMetric = profile.metric[WEIGHT];
  const startingWeightBMI = getBMI(metricHeight, startingWeightMetric);

  // Show notice to users who are appropriate BMI.
  const showEligibilityMessage =
    HIGH_BMI <= startingWeightBMI && startingWeightBMI < OBESE_BMI;

  return showEligibilityMessage;
};
